import Repository from './Repository'

const resource = 'off-day-types'

export default {
  getTypes (params) {
    return Repository.get(`${resource}`, { params: params })
  }
}
